import SvgIcons from "../../../shared/components/svgIcons";
import Forecast from "../components/forecast-graph-chatbot";

const forecastRoute = [
  {
    path: "forecast",
    element: <Forecast />,
    link: "forecast",
    name: "Forecast",
    permission: "Forecast",
    icon: SvgIcons.ForecastIcon,
    index: 2,
  },
];
export default forecastRoute;
